import { render } from "./ProjectView.vue?vue&type=template&id=612f7ee4"
import script from "./ProjectView.vue?vue&type=script&lang=js"
export * from "./ProjectView.vue?vue&type=script&lang=js"

import "./ProjectView.vue?vue&type=style&index=0&id=612f7ee4&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/view/ProjectView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "612f7ee4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('612f7ee4', __exports__)) {
    api.reload('612f7ee4', __exports__)
  }
  
  module.hot.accept("./ProjectView.vue?vue&type=template&id=612f7ee4", () => {
    api.rerender('612f7ee4', render)
  })

}


export default __exports__